import { Box, Flex, HStack, Text } from '@chakra-ui/react';
import { Outlet, Link } from 'react-router-dom';
import { Navbar } from './Navbar';
import { OnboardingTour } from '../common/OnboardingTour';
import { useUser } from '../../contexts/UserContext';

export const Layout = () => {
  const { userData } = useUser();
  const showOnboarding = userData && !userData.completedOnboarding;

  return (
    <Flex direction="column" minH="100vh" bg="gray.50" overflowX="hidden">
      <Navbar />
      <Box as="main" flex="1" maxW="7xl" mx="auto" w="full" px={4} py={8} minW={0}>
        <Outlet />
      </Box>
      <Box py={4} px={4} borderTopWidth={1} borderColor="gray.200">
        <Flex maxW="7xl" mx="auto" justify="space-between" align="center" flexWrap="wrap" gap={2}>
          <Text color="gray.400" fontSize="xs">
            &copy; {new Date().getFullYear()} attributed.to
          </Text>
          <HStack spacing={4}>
            <Text as={Link} to="/terms" color="gray.400" fontSize="xs" _hover={{ color: 'gray.600' }}>
              Terms of Service
            </Text>
            <Text as={Link} to="/privacy" color="gray.400" fontSize="xs" _hover={{ color: 'gray.600' }}>
              Privacy Policy
            </Text>
          </HStack>
        </Flex>
      </Box>
      {showOnboarding && <OnboardingTour />}
    </Flex>
  );
};
